import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { site } from "@/config/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [mobileCat, setMobileCat] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    setMobileCat(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50 border-b border-background-200"
      }`}
    >
      <nav className="container-x flex h-16 items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-xl" />
          </span>
          <span className="font-heading text-lg font-black text-foreground-950">
            {site.name}
            <span className="ml-2 hidden rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-800 sm:inline">
              {site.slogan}
            </span>
          </span>
        </Link>

        <div className="hidden items-center gap-1 lg:flex">
          <Link
            to="/"
            className={`rounded-md px-3 py-2 text-sm font-medium transition-colors hover:bg-background-100 ${
              location.pathname === "/" ? "text-primary-700" : "text-foreground-700"
            }`}
          >
            首页
          </Link>
          {categories.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className={`rounded-md px-3 py-2 text-sm font-medium transition-colors hover:bg-background-100 ${
                location.pathname === `/category/${c.slug}`
                  ? "text-primary-700"
                  : "text-foreground-700"
              }`}
            >
              {c.name}
            </Link>
          ))}
          <Link
            to="/faq"
            className={`rounded-md px-3 py-2 text-sm font-medium transition-colors hover:bg-background-100 ${
              location.pathname === "/faq" ? "text-primary-700" : "text-foreground-700"
            }`}
          >
            常见问题
          </Link>
        </div>

        <div className="hidden items-center gap-3 lg:flex">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 rounded-md border border-background-300 px-4 py-2 text-sm font-medium whitespace-nowrap text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-information-line" />
            关于我们
          </Link>
          <Link
            to="/faq"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-sparkling-line" />
            开始浏览
          </Link>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="container-x flex flex-col gap-1 py-4">
            <Link
              to="/"
              className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
            >
              首页
            </Link>
            <button
              type="button"
              onClick={() => setMobileCat((v) => !v)}
              className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
            >
              剧情分类
              <i className={`${mobileCat ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-lg`} />
            </button>
            {mobileCat && (
              <div className="ml-3 flex flex-col border-l border-background-200">
                {categories.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/category/${c.slug}`}
                    className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
                  >
                    {c.name} <span className="text-foreground-400">{c.en}</span>
                  </Link>
                ))}
              </div>
            )}
            <Link
              to="/faq"
              className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
            >
              常见问题
            </Link>
            <Link
              to="/about"
              className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
            >
              关于我们
            </Link>
            <Link
              to="/faq"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold whitespace-nowrap text-background-50"
            >
              <i className="ri-sparkling-line" />
              开始浏览
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}